export default "__VITE_ASSET__CcJfG9iT__"